import { Injectable, OnInit } from '@angular/core';
import { TextboxQuestion } from '../../question-textbox';
import { Inputfiledsbase } from '../../models/inputfiledsbase';
import { of, Observable, map } from 'rxjs';
import { TextareaQuestion } from '../../question-textarea';
import { DropdownQuestion } from '../../question-dropdown';
import { DatepickerQuestion } from '../../question-datepicker';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { CheckboxQuestion } from '../../question-checkbox';
import { DropdownservicesService } from '../../../Services/Apis/Dropdownservices/dropdownservices.service';
import { StudentfromcontrolService } from '../../../Services/controllers/studentfromcontrol.service';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {
  password: any;
  organisationdata: any = [];
  Genderdata: any = [];
  DepartmentName: any = [];
  Castesdata: any = [];
  Religionsdata: any = [];
  Statuesdata: any = [];
  Employeetype: any = [];
  Appointenttype: any = [];
  Coursesdata: any = [];
  Countrydata: any = [];
  Statedata: any = [];
  Qualificationdata: any = [];
  Designeationdata: any = [];
  Salarydata: any = [];
  Activitydata: any = [];
  Scholarlyworkdata: any = [];
  Platformdata: any = [];
  Userrolesdata: any = [];
  Usermanagerdata: any = [];
  selecteddepartmentValue: any;
  empformcontrols: any;

  constructor(
    private apiservice: ApiservicesService,
    private store: Store,
    private empformcontrol: StudentfromcontrolService,
    private dropdownservice: DropdownservicesService,
  ) {
    // this.loadDropdownData('EMPLOYMENT_TYPES', this.Employeetype);
    // this.loadDropdownData('APPOINTMENT_TYPES', this.Appointenttype);
    // this.loadDropdownData('DEPARTMENTS', this.DepartmentName);
    // this.loadDropdownData('DESIGNATIONS', this.Designeationdata);
    // this.loadDropdownData('GENDER', this.Genderdata);
    // this.loadDropdownData('SALARY_MODES', this.Salarydata);
    // this.loadDropdownData('USER_ROLES', this.Userrolesdata);
    // this.loadDropdownData('COURSES', this.Coursesdata);
    // this.loadDropdownData('CASTES', this.Castesdata);
    // this.loadDropdownData('RELIGIONS', this.Religionsdata);
    // this.loadDropdownData('STATUSES', this.Statuesdata);
    // this.loadDropdownData('COUNTRY_NAMES', this.Countrydata);
    // this.loadDropdownData('INDIA', this.Statedata);
    // this.loadDropdownData('QUALIFICATIONS', this.Qualificationdata);
    // this.loadDropdownData('PASSWORD', this.password);
    this.store
      .select((state: any) => state.empform)
      .subscribe((res) => {
        this.empformcontrols = res?.Employeeform;
      });

    this.apiservice.getpasswordemployee().subscribe((res) => {
      this.password = res.data.password;
    });
  }

  title_dropdown: any = [
    { key: 'Mr.', id: 'Mr', value: 'Mr.' },
    { key: 'Ms.', id: 'Ms', value: 'Ms.' },
    { key: 'Mrs.', id: 'Mrs', value: 'Mrs.' },
  ];

  Faculty_teaching: any = [
    { key: 'UG', id: 'UG', value: 'UG' },
    { key: 'PG', id: 'PG', value: 'PG' },
  ];
  public loadDropdownData(code: string, dataArray: any[]) {
    let observable: Observable<any>;

    if (code === 'DEPARTMENTS') {
      observable = this.dropdownservice.getdepartmentdrop();
    } else if (code === 'USER_ROLES') {
      observable = this.dropdownservice.getuserroledropdown();
    } else if (code === 'DESIGNATIONS') {
      observable = this.dropdownservice.getdesignationsdrop();
    } else if (code === 'COUNTRY_NAMES') {
      observable = this.dropdownservice.getgeoservicecountry();
    } else if (code === 'STATE_NAMES') {
      observable = this.dropdownservice.getgeoservicestate();
    } else if (code === 'MANAGER') {
      observable = this.dropdownservice.getEmployeedrop({
        department_id: this.selecteddepartmentValue,
      });
    } else {
      observable = this.dropdownservice.getlookupcodesdropdown(code);
    }

    observable.subscribe((res) => {
      // if(res instanceof Array){
      for (
        let i = 0;
        code === 'STATE_NAMES' ? i < res.state?.length : i < res?.length;
        i++
      ) {
        let lookupname;
        if (code === 'DEPARTMENTS') {
          lookupname = res[i].department_name;
        } else if (code === 'USER_ROLES') {
          lookupname = res[i].name;
        } else if (code === 'DESIGNATIONS' || code === 'MANAGER') {
          lookupname = res[i].name;
        } else if (code === 'COUNTRY_NAMES') {
          lookupname = res[i].country_name;
        } else if (code === 'STATE_NAMES') {
          lookupname = res.state[i].state_name;
        } else {
          lookupname = res[i].lookup_name;
        }
        dataArray.push({
          id: code === 'STATE_NAMES' ? res.state[i].id : res[i].id,
          key: lookupname,
          value: code === 'STATE_NAMES' ? res.state[i].id : res[i].id,
        });
      }
      // }else{
      //   this.password = res.password
      // }
    });
  }

  getselecteddepartmentValue(value: any) {
    this.selecteddepartmentValue = value;
    this.onchangedrops();
  }

  onchangedrops() {
    this.Usermanagerdata.splice(0, this.Usermanagerdata.length);
    this.Designeationdata.splice(0, this.Designeationdata.length);
    this.loadDropdownData('MANAGER', this.Usermanagerdata);
    this.loadDropdownData('DESIGNATIONS', this.Designeationdata);
  }

  resetdropdowns() {
    this.Genderdata.splice(0, this.Genderdata.length);
    this.Userrolesdata.splice(0, this.Userrolesdata.length);
    this.Castesdata.splice(0, this.Castesdata.length);
    this.Religionsdata.splice(0, this.Religionsdata.length);
    this.Statuesdata.splice(0, this.Statuesdata.length);
    this.Employeetype.splice(0, this.Employeetype.length);
    this.Appointenttype.splice(0, this.Appointenttype.length);
    this.DepartmentName.splice(0, this.DepartmentName.length);
    this.Designeationdata.splice(0, this.Designeationdata.length);
    this.Salarydata.splice(0, this.Salarydata.length);
    this.Countrydata.splice(0, this.Countrydata.length);
    this.Statedata.splice(0, this.Statedata.length);
    this.Scholarlyworkdata.splice(0, this.Scholarlyworkdata.length);
    this.Platformdata.splice(0, this.Platformdata.length);
    this.Usermanagerdata.splice(0, this.Usermanagerdata.length);
    this.Activitydata.splice(0, this.Activitydata.length);
    this.Qualificationdata.splice(0, this.Qualificationdata.length);
  }

  getfilterformdata(
    FilterKey: string,
    filterObservable$: Observable<any[]>,
  ): Observable<any> {

    let DATA: any;
    filterObservable$.subscribe((q: any) => {
      DATA = q;
    });

    const disableMap = new Map(
      this.empformcontrols[FilterKey].map((item: any) => [
        item.key,
        !item.hidden,
      ]),
    );

    return filterObservable$.pipe(
      map((data: any[]) =>
        data
          // 1️⃣ Remove hidden = true
          .filter((item) => disableMap.get(item.key) === true)

          // 2️⃣ Update required field
          .map((item) => ({
            ...item,
            required: true,
          })),
      ),
    );
  }

  getemployeeform() {
    this.resetdropdowns();
    this.loadDropdownData('GENDER', this.Genderdata);
    this.loadDropdownData('USER_ROLES', this.Userrolesdata);
    this.loadDropdownData('CASTES', this.Castesdata);
    this.loadDropdownData('RELIGIONS', this.Religionsdata);
    this.loadDropdownData('STATUSES', this.Statuesdata);
    // this.loadDropdownData('MANAGER', this.Usermanagerdata);

    const questions: Inputfiledsbase<string | Number>[] = [
      new TextboxQuestion({
        key: 'employee_unique_id',
        label: 'Employee Unique Id',
        required: false,
        order: 2,
      }),

      new DropdownQuestion({
        key: 'title',
        label: 'Title',
        required: true,
        options: this.title_dropdown,
        value: 'Mr.',
        order: 4,
      }),

      new TextboxQuestion({
        key: 'first_name',
        label: 'First Name',
        // value: 'Bombasto',
        required: true,
        patterns: '[a-zA-Z ]*',
        order: 5,
      }),

      new TextboxQuestion({
        key: 'last_name',
        label: 'Last name',
        required: true,
        patterns: '[a-zA-Z ]*',
        order: 7,
      }),

      new DatepickerQuestion({
        key: 'date_of_birth',
        label: 'Date Of Birth',
        type: 'datepicker',
        required: false,
        order: 8,
      }),

      new DropdownQuestion({
        key: 'gender_id',
        label: 'Gender',
        required: true,
        // patterns: '^d{10}$',
        options: this.Genderdata,
        order: 9,
      }),

      new DropdownQuestion({
        key: 'religion_id',
        label: 'Religion',
        type: 'text',
        options: this.Religionsdata,
        required: false,
        order: 10,
      }),

      new DropdownQuestion({
        key: 'caste_id',
        label: 'Caste Category',
        required: false,
        options: this.Castesdata,
        // patterns: '^d{10}$',
        order: 11,
      }),

      new TextboxQuestion({
        key: 'sub_caste',
        label: 'Sub Caste',
        type: 'text',
        // value: 'Bombasto',
        required: false,
        order: 12,
      }),

      new TextboxQuestion({
        key: 'adhar_number',
        label: 'Aadhaar Number',
        type: 'text',
        required: false,
        patterns: '^[0-9]{12}$',
        minLength: 12,
        maxLength: 12,
        order: 13,
      }),

      new TextboxQuestion({
        key: 'pan_number',
        label: 'PAN Number',
        type: 'text',
        required: false,
        patterns: '^[A-Z]{5}[0-9]{4}[A-Z]$',
        minLength: 10,
        maxLength: 10,
        order: 14,
      }),

      new TextboxQuestion({
        key: 'phone_number',
        label: 'Mobile Number',
        type: 'text',
        required: true,
        patterns: '^[0-9]*$',
        minLength: 10,
        maxLength: 10,
        order: 15,
      }),

      new TextboxQuestion({
        key: 'alternate_mobile_number',
        label: 'Alternate Mobile Number',
        type: 'text',
        required: false,
        patterns: '^[0-9]*$',
        minLength: 10,
        maxLength: 10,
        order: 16,
      }),

      new TextboxQuestion({
        key: 'personal_email',
        label: 'Personal Email',
        type: 'email',
        patterns: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
        required: false,
        order: 17,
      }),

      new TextboxQuestion({
        key: 'father_name',
        label: 'Father Name',
        required: false,
        patterns: '[a-zA-Z ]*',
        order: 18,
      }),

      new TextboxQuestion({
        key: 'mother_name',
        label: 'Mother Name',
        required: false,
        patterns: '[a-zA-Z ]*',
        order: 19,
      }),

      new TextboxQuestion({
        key: 'password',
        label: 'Password',
        type: 'password',
        required: true,
        minLength: 12,
        maxLength: 100,
        order: 20,
      }),

      new DropdownQuestion({
        key: 'user_role_id',
        label: 'User Role',
        required: true,
        patterns: '^\\d+$',
        options: this.Userrolesdata,
        order: 21,
      }),

      new DropdownQuestion({
        key: 'status_id',
        label: 'Status',
        options: this.Statuesdata,
        required: true,
        order: 22,
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }

  getExperienceForm() {
    const questions: Inputfiledsbase<Number>[] = [
      new TextboxQuestion({
        key: 'designation',
        label: 'Designation',
        type: 'text',
        required: true,
        order: 1,
      }),

      new TextboxQuestion({
        key: 'organization_name',
        label: 'Organization Name',
        type: 'text',
        required: true,
        order: 2,
      }),

      new TextboxQuestion({
        key: 'location',
        label: 'Village/City',
        type: 'text',
        required: true,
        order: 3,
      }),

      new DatepickerQuestion({
        key: 'start_date',
        label: 'Join Date',
        type: 'datepicker',
        // value: false,
        required: true,
        order: 4,
      }),

      new DatepickerQuestion({
        key: 'end_date',
        label: 'Release Date',
        type: 'datepicker',
        // value: false,
        required: true,
        order: 5,
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }

  getScholarly_workForm() {
    this.resetdropdowns();
    this.Scholarlyworkdata.splice(0, this.Scholarlyworkdata.length);
    this.Platformdata.splice(0, this.Platformdata.length);
    this.Activitydata.splice(0, this.Activitydata.length);
    this.loadDropdownData('SCHOLARLY_WORK_TYPES', this.Scholarlyworkdata);
    this.loadDropdownData('ACTIVITY_TYPES', this.Activitydata);
    this.loadDropdownData('PLATFORM', this.Platformdata);

    const questions: Inputfiledsbase<Number>[] = [
      new TextboxQuestion({
        key: 'title',
        label: 'Title',
        type: 'text',
        required: true,
        order: 1,
      }),

      new DropdownQuestion({
        key: 'scholarly_work_type_id',
        label: 'Scholarly Work Type',
        required: true,
        options: this.Scholarlyworkdata,
        order: 2,
      }),

      new DropdownQuestion({
        key: 'activity_type',
        label: 'Activity Type',
        required: true,
        options: this.Activitydata,
        order: 3,
      }),

      new DropdownQuestion({
        key: 'platform_id',
        label: 'Platform Type',
        required: true,
        options: this.Platformdata,
        order: 4,
      }),

      new DatepickerQuestion({
        key: 'year',
        label: 'Release Date',
        type: 'datepicker',
        // value: false,
        required: true,
        order: 5,
      }),

      new TextareaQuestion({
        key: 'description',
        label: 'Description',
        type: 'text',
        required: false,
        order: 6,
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }

  getJoiningFrom() {
    this.resetdropdowns();
    this.loadDropdownData('EMPLOYMENT_TYPES', this.Employeetype);
    this.loadDropdownData('APPOINTMENT_TYPES', this.Appointenttype);
    this.loadDropdownData('DEPARTMENTS', this.DepartmentName);
    this.loadDropdownData('DESIGNATIONS', this.Designeationdata);

    const questions: Inputfiledsbase<String | Number>[] = [
      new DatepickerQuestion({
        key: 'date_of_joining',
        label: 'Date of Joining',
        type: 'datepicker',
        // value: false,
        required: true,
        order: 1,
      }),

      new TextboxQuestion({
        key: 'professional_email',
        label: 'Professional Email',
        type: 'email',
        patterns: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
        required: true,
        order: 3,
      }),

      new DropdownQuestion({
        key: 'employment_type_id',
        label: 'Employment Type',
        required: false,
        options: this.Employeetype,
        order: 4,
      }),

      new DropdownQuestion({
        key: 'appointment_type_id',
        label: 'Appointment Type',
        required: false,
        options: this.Appointenttype,
        order: 5,
      }),

      new DropdownQuestion({
        key: 'department_id',
        label: 'Department Name',
        options: this.DepartmentName,
        required: true,
        onChange: this.getselecteddepartmentValue.bind(this),
        order: 6,
      }),

      new DropdownQuestion({
        key: 'manager_id',
        label: 'Manager',
        required: false,
        patterns: '^\\d+$',
        options: this.Usermanagerdata,
        order: 7,
      }),

      new DropdownQuestion({
        key: 'designation_id',
        label: 'Designation',
        required: true,
        options: this.Designeationdata,
        order: 9,
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }

  getSalaryForm() {
    this.resetdropdowns();
    this.loadDropdownData('SALARY_MODES', this.Salarydata);

    const questions: Inputfiledsbase<String | Number>[] = [
      new TextboxQuestion({
        key: 'pay_scale',
        label: 'Pay Scale',
        type: 'Number',
        required: false,
        patterns: '^\\d+(\\.\\d{1,2})?$',
        order: 18,
      }),

      new TextboxQuestion({
        key: 'gross_pay_per_month',
        label: 'Gross Pay Per Month',
        type: 'text',
        required: false,
        patterns: '^\\d+(\\.\\d{1,2})?$',
        minLength: 1,
        maxLength: 10,
        order: 34,
      }),

      new TextboxQuestion({
        key: 'hra_in_rupees',
        label: 'HRA in Rs.',
        type: 'text',
        required: false,
        patterns: '^\\d+(\\.\\d{1,2})?$',
        order: 35,
      }),

      new TextboxQuestion({
        key: 'basic_pay',
        label: 'Basic pay in Rs.',
        type: 'text',
        required: false,
        patterns: '^\\d+(\\.\\d{1,2})?$',
        order: 35,
      }),

      new TextboxQuestion({
        key: 'other_allowances',
        label: 'Other Allowances in Rs.',
        type: 'text',
        required: false,
        patterns: '^\\d+(\\.\\d{1,2})?$',
        order: 35,
      }),

      new DropdownQuestion({
        key: 'salary_mode_id',
        label: 'Salary Mode',
        required: false,
        options: this.Salarydata,
        order: 33,
      }),

      new TextboxQuestion({
        key: 'pf_number',
        label: 'PF Number',
        type: 'text',
        required: false,
        patterns: '^[a-zA-Z0-9]{6,12}$',
        minLength: 6,
        maxLength: 12,
        order: 30,
      }),

      new TextboxQuestion({
        key: 'esi_number',
        label: 'ESIC Number',
        type: 'text',
        required: false,
        patterns: '^[a-zA-Z0-9]{10,17}$',
        minLength: 10,
        maxLength: 17,
        order: 31,
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }

  getBankdetailsForm() {
    this.resetdropdowns();
    this.loadDropdownData('SALARY_MODES', this.Salarydata);

    const questions: Inputfiledsbase<String | Number>[] = [
      new TextboxQuestion({
        key: 'bank_name',
        label: 'Bank Name',
        type: 'text',
        required: false,
        order: 1,
      }),

      new TextboxQuestion({
        key: 'bank_account_number',
        label: 'Bank Account Number',
        type: 'text',
        required: false,
        patterns: '^[0-9]{11,18}$',
        minLength: 11,
        maxLength: 18,
        order: 2,
      }),

      new TextboxQuestion({
        key: 'bank_branch_name',
        label: 'Bank Branch Name',
        type: 'text',
        required: false,
        patterns: "^[a-zA-Zsd&.'()]*$",
        order: 3,
      }),

      new TextboxQuestion({
        key: 'bank_ifsc_code',
        label: 'IFSC Code',
        type: 'text',
        required: false,
        minLength: 11,
        maxLength: 11,
        patterns: '/^[A-Z]{4}0[A-Z0-9]{6}$/',
        order: 4,
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }

  getAddressForm() {
    this.resetdropdowns();
    this.loadDropdownData('COUNTRY_NAMES', this.Countrydata);
    this.loadDropdownData('STATE_NAMES', this.Statedata);

    const questions: Inputfiledsbase<String | Number>[] = [
      new DropdownQuestion({
        key: 'country_id',
        label: 'Country',
        type: 'text',
        required: true,
        options: this.Countrydata,
        order: 1,
      }),

      new DropdownQuestion({
        key: 'state_id',
        label: 'State',
        type: 'text',
        required: true,
        options: this.Statedata,
        order: 2,
      }),

      new TextareaQuestion({
        key: 'address_line1',
        label: 'Address Line 1',
        type: 'text',
        required: true,
        order: 4,
      }),

      new TextareaQuestion({
        key: 'address_line2',
        label: 'Address Line 2',
        type: 'text',
        required: true,
        order: 5,
      }),

      new TextboxQuestion({
        key: 'city',
        label: 'City',
        type: 'text',
        required: true,
        order: 3,
      }),

      new TextboxQuestion({
        key: 'pincode',
        label: 'PIN Code',
        type: 'text',
        required: true,
        order: 6,
        minLength: 6,
        maxLength: 6,
        patterns: '^[0-9]*$',
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }

  getPermanetcheckbox() {
    const questions: Inputfiledsbase<String | Number>[] = [
      new CheckboxQuestion({
        key: 'is_permanent',
        label: 'is permanent',
        required: false,
        order: 1,
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }

  getEducationalDetails() {
    this.resetdropdowns();
    this.loadDropdownData('QUALIFICATIONS', this.Qualificationdata);

    const questions: Inputfiledsbase<String | Number>[] = [
      new DropdownQuestion({
        key: 'qualification_id',
        label: 'Qualification',
        type: 'text',
        options: this.Qualificationdata,
        required: true,
        order: 2,
      }),

      new DatepickerQuestion({
        key: 'start_year',
        label: 'Start Year',
        type: 'text',
        required: true,
        patterns: '^(19|20)d{2}$',
        order: 3,
      }),

      new DatepickerQuestion({
        key: 'end_year',
        label: 'End Year',
        type: 'text',
        required: true,
        patterns: '^(19|20)d{2}$',
        order: 4,
      }),

      new TextboxQuestion({
        key: 'university_name',
        label: 'University Name',
        type: 'text',
        required: true,
        order: 5,
      }),

      new TextboxQuestion({
        key: 'institution_name',
        label: 'Institution Name',
        type: 'text',
        required: true,
        order: 6,
      }),

      new TextboxQuestion({
        key: 'course_name',
        label: 'Course Name',
        type: 'text',
        required: true,
        order: 7,
      }),

      new TextboxQuestion({
        key: 'percentage',
        label: 'Percentage',
        type: 'number', // Assuming the percentage is entered as text
        required: true,
        patterns: '^100$|^[123456789][0-9]$|^[0-9]$', // Pattern to match percentages from 0 to 100
        order: 8,
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }

  getFilterDropdowns(): Observable<Inputfiledsbase<string>[]> {
    this.resetdropdowns();
    this.loadDropdownData('DEPARTMENTS', this.DepartmentName);

    const questions: Inputfiledsbase<string>[] = [
      new DropdownQuestion({
        key: 'department_id',
        label: 'Department Name',
        options: this.DepartmentName,
        required: false,
        order: 1,
      }),
    ];

    return of(questions.sort((a, b) => a.order - b.order));
  }
}
